
declare global {
    function assert(condition: unknown, message?: string): asserts condition;
}

(globalThis as any).assert = function (condition: unknown, message = 'Assertion failed'): asserts condition {
    if (!condition) {
        throw new Error(message);
    }
};

import * as import_1 from ".\/prolog.js";
import * as import_2 from ".\/themes\/smsmachmit\/scripts\/FormSubmitHandler";
import * as import_3 from ".\/themes\/smsmachmit\/scripts\/Hamburger";
import * as import_4 from ".\/themes\/smsmachmit\/scripts\/Menu";
import * as import_5 from ".\/themes\/smsmachmit\/scripts\/ScrollToTop";
import * as import_6 from ".\/themes\/smsmachmit\/scripts\/Sidepane";
import * as import_7 from ".\/themes\/smsmachmit\/scripts\/SlideShow";
import * as import_8 from ".\/themes\/smsmachmit\/scripts\/Slider";
import * as import_9 from ".\/themes\/smsmachmit\/scripts\/SliderNavigation";
import * as import_10 from ".\/themes\/smsmachmit\/scripts\/SmoothScroll";
import * as import_11 from ".\/themes\/smsmachmit\/scripts\/Sticky";
import * as import_12 from ".\/themes\/smsmachmit\/scripts\/TabLoop";
import * as import_13 from ".\/themes\/smsmachmit\/scripts\/animations\/AbstractAnimation";
import * as import_14 from ".\/themes\/smsmachmit\/scripts\/animations\/BaseAnimation";
import * as import_15 from ".\/themes\/smsmachmit\/scripts\/animations\/BaseAnimations";
import * as import_16 from ".\/themes\/smsmachmit\/scripts\/animations\/ClipInsetAnimation";
import * as import_17 from ".\/themes\/smsmachmit\/scripts\/animations\/FadeAnimation";
import * as import_18 from ".\/themes\/smsmachmit\/scripts\/animations\/GroupAnimation";
import * as import_19 from ".\/themes\/smsmachmit\/scripts\/animations\/HeightAnimation";
import * as import_20 from ".\/themes\/smsmachmit\/scripts\/animations\/ScrollLeftAnimation";
import * as import_21 from ".\/themes\/smsmachmit\/scripts\/animations\/ScrollTopAnimation";
import * as import_22 from ".\/themes\/smsmachmit\/scripts\/animations\/SlideAnimation";
import * as import_23 from ".\/themes\/smsmachmit\/scripts\/engines\/AbstractEngine";
import * as import_24 from ".\/themes\/smsmachmit\/scripts\/engines\/JQueryEngine";
import * as import_25 from ".\/themes\/smsmachmit\/scripts\/engines\/WebAnimationEngine";
import * as import_26 from ".\/themes\/smsmachmit\/scripts\/player\/CustomPlayer";
import * as import_27 from ".\/themes\/smsmachmit\/scripts\/player\/Player";
import * as import_28 from ".\/themes\/smsmachmit\/scripts\/player\/VideoPlayer";
import * as import_29 from ".\/themes\/smsmachmit\/scripts\/promises\/EventPromise";
import * as import_30 from ".\/themes\/smsmachmit\/scripts\/promises\/ImageLoadPromise";
import * as import_31 from ".\/themes\/smsmachmit\/scripts\/promises\/TimeoutPromise";
import * as import_32 from ".\/themes\/smsmachmit\/scripts\/widgets\/Checkbox";
import * as import_33 from ".\/themes\/smsmachmit\/scripts\/widgets\/Select";
import * as import_34 from ".\/themes\/smsmachmit\/scripts\/widgets\/TextInput";
export const imports={
...import_1,
...import_2,
...import_3,
...import_4,
...import_5,
...import_6,
...import_7,
...import_8,
...import_9,
...import_10,
...import_11,
...import_12,
...import_13,
...import_14,
...import_15,
...import_16,
...import_17,
...import_18,
...import_19,
...import_20,
...import_21,
...import_22,
...import_23,
...import_24,
...import_25,
...import_26,
...import_27,
...import_28,
...import_29,
...import_30,
...import_31,
...import_32,
...import_33,
...import_34,
}
